import { createFileRoute } from '@tanstack/react-router'
import { RoleList } from '@/features/roles/role-list'

/** The roles index. The `role.view` guard lives on the parent layout route. */
export const Route = createFileRoute('/_authenticated/roles/')({
  component: RoleList,
})
